export default __webpack_public_path__ + "static/media/eventBanner.a15d6a5c.webp";